export enum ContributorPermission {
  Admin = 'admin',
  Write = 'write',
  Read = 'read',
}
